import React from 'react';
import { archives } from './archives';

function ArchivesPage({ onSelectArchive, onBack }) {
  return (
    <div className="archives-page" style={{ padding: '2em', maxWidth: 600, margin: '0 auto' }}>
      <h2 style={{ color: '#c94f7c', marginBottom: '1em' }}>Letter Archives</h2>
      <button onClick={onBack} style={{ marginBottom: '1em' }}>Back</button>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {archives.map(archive => (
          <li key={archive.id} style={{ marginBottom: '1.5em', borderBottom: '1px solid #eee', paddingBottom: '1em' }}>
            <div style={{ fontWeight: 600 }}>{archive.title}</div>
            <div style={{ color: '#b07a8c', fontSize: '0.95em' }}>{archive.dateArchived}</div>
            <button onClick={() => onSelectArchive(archive)} style={{ marginTop: 8 }}>View</button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default ArchivesPage;
